import { render, staticRenderFns } from "./ExpedienteActionsRenderer.vue?vue&type=template&id=4e3164d1"
import script from "./ExpedienteActionsRenderer.vue?vue&type=script&lang=js"
export * from "./ExpedienteActionsRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports